import { useState } from 'react';
import BsCarousel from 'react-bootstrap/Carousel';
import styled from 'styled-components';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

interface ICarouselProps {
  images: string[];
}

interface IStyledCarouselItemProps {
  src: string;
}

export const StyledCarouselItem = styled.div<IStyledCarouselItemProps>`
  background-image: ${({ src: imageUrl }) => `url(${imageUrl})`};
  height: 20rem;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const StyledCarousel = styled(BsCarousel)`
  margin-bottom: 4px;
`;

export const RoomImageSlider = ({ images }: ICarouselProps) => {
  const [active, setActive] = useState(0);
  return (
    <StyledCarousel
      fade
      activeIndex={active}
      onSelect={(idx) => setActive(idx)}
      controls={images?.length > 1}
      indicators={images?.length > 1}>
      {images?.map((item) => (
        <BsCarousel.Item key={item} style={{ minHeight: '20rem' }}>
          <LazyLoadComponent threshold={0}>
            <StyledCarouselItem src={item} className="d-block w-100" />
          </LazyLoadComponent>
        </BsCarousel.Item>
      ))}
    </StyledCarousel>
  );
};
